import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select, { components as defaultComponents } from 'react-select';
import defaultShouldLoadMore from './default-should-load-more';
import defaultReduceOptions from './default-reduce-options';
import wrapMenuList from './wrap-menu-list';
export var MenuList = wrapMenuList(defaultComponents.MenuList);

var sleep = function sleep(ms) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, ms);
  });
};

var AsyncPaginateBase = /*#__PURE__*/function (_Component) {
  _inherits(AsyncPaginateBase, _Component);

  var _super = _createSuper(AsyncPaginateBase);

  function AsyncPaginateBase(props) {
    var _this;

    _classCallCheck(this, AsyncPaginateBase);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleScrolledToBottom", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var inputValue, optionsCache, currentOptions;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              inputValue = _this.props.inputValue;
              optionsCache = _this.state.optionsCache;
              currentOptions = optionsCache[inputValue];

              if (!currentOptions) {
                _context.next = 6;
                break;
              }

              _context.next = 6;
              return _this.loadOptions();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    var options = props.options,
        defaultOptions = props.defaultOptions;
    var initialOptions = defaultOptions === true ? null : defaultOptions instanceof Array ? defaultOptions : options;
    var initialOptionsCache = initialOptions ? {
      '': {
        isFirstLoad: false,
        isLoading: false,
        options: initialOptions,
        hasMore: true,
        additional: props.additional
      }
    } : {};
    _this.state = {
      optionsCache: initialOptionsCache
    };
    return _this;
  }

  _createClass(AsyncPaginateBase, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var defaultOptions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                defaultOptions = this.props.defaultOptions;

                if (!(defaultOptions === true)) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.loadOptions();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function () {
      var _componentDidUpdate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(oldProps) {
        var _this$props, cacheUniq, defaultOptions, inputValue, menuIsOpen;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this$props = this.props, cacheUniq = _this$props.cacheUniq, defaultOptions = _this$props.defaultOptions, inputValue = _this$props.inputValue, menuIsOpen = _this$props.menuIsOpen;

                if (!(oldProps.cacheUniq !== cacheUniq)) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 4;
                return this.setState({
                  optionsCache: {}
                });

              case 4:
                if (!(defaultOptions === true)) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 7;
                return this.loadOptions();

              case 7:
                _context3.next = 11;
                break;

              case 9:
                if (inputValue !== oldProps.inputValue) {
                  this.handleInputChange(inputValue);
                }

                if (menuIsOpen && !oldProps.menuIsOpen) {
                  this.onMenuOpen();
                }

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidUpdate(_x) {
        return _componentDidUpdate.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: "onMenuOpen",
    value: function () {
      var _onMenuOpen = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var loadOptionsOnMenuOpen, optionsCache;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loadOptionsOnMenuOpen = this.props.loadOptionsOnMenuOpen;
                optionsCache = this.state.optionsCache;

                if (!(!optionsCache[''] && loadOptionsOnMenuOpen)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 5;
                return this.loadOptions();

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onMenuOpen() {
        return _onMenuOpen.apply(this, arguments);
      }

      return onMenuOpen;
    }()
  }, {
    key: "getInitialCache",
    value: function getInitialCache() {
      var additional = this.props.additional;
      return {
        isFirstLoad: true,
        options: [],
        hasMore: true,
        isLoading: false,
        additional: additional
      };
    }
  }, {
    key: "handleInputChange",
    value: function () {
      var _handleInputChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(search) {
        var optionsCache;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                optionsCache = this.state.optionsCache;

                if (optionsCache[search]) {
                  _context5.next = 4;
                  break;
                }

                _context5.next = 4;
                return this.loadOptions();

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function handleInputChange(_x2) {
        return _handleInputChange.apply(this, arguments);
      }

      return handleInputChange;
    }()
  }, {
    key: "loadOptions",
    value: function () {
      var _loadOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var inputValue, optionsCache, currentOptions, debounceTimeout, newInputValue, hasError, additional, options, hasMore, _loadOptions2, response, newAdditional, reduceOptions;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                inputValue = this.props.inputValue;
                optionsCache = this.state.optionsCache;
                currentOptions = optionsCache[inputValue] || this.getInitialCache();

                if (!(currentOptions.isLoading || !currentOptions.hasMore)) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt("return");

              case 5:
                _context6.next = 7;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: _objectSpread({}, prevState.optionsCache, _defineProperty({}, inputValue, _objectSpread({}, currentOptions, {
                      isLoading: true
                    })))
                  };
                });

              case 7:
                debounceTimeout = this.props.debounceTimeout;

                if (!(debounceTimeout > 0)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 11;
                return sleep(debounceTimeout);

              case 11:
                newInputValue = this.props.inputValue;

                if (!(inputValue !== newInputValue)) {
                  _context6.next = 16;
                  break;
                }

                _context6.next = 15;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: _objectSpread({}, prevState.optionsCache, _defineProperty({}, inputValue, _objectSpread({}, prevState.optionsCache[inputValue], {
                      isLoading: false
                    })))
                  };
                });

              case 15:
                return _context6.abrupt("return");

              case 16:
                _context6.prev = 16;
                _loadOptions2 = this.props.loadOptions;
                _context6.next = 20;
                return _loadOptions2(inputValue, currentOptions.options, currentOptions.additional);

              case 20:
                response = _context6.sent;
                options = response.options;
                hasMore = response.hasMore;
                additional = response.additional;
                hasError = false;
                _context6.next = 30;
                break;

              case 27:
                _context6.prev = 27;
                _context6.t0 = _context6["catch"](16);
                hasError = true;

              case 30:
                if (!hasError) {
                  _context6.next = 35;
                  break;
                }

                _context6.next = 33;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: _objectSpread({}, prevState.optionsCache, _defineProperty({}, inputValue, _objectSpread({}, currentOptions, {
                      isLoading: false
                    })))
                  };
                });

              case 33:
                _context6.next = 39;
                break;

              case 35:
                newAdditional = typeof additional === 'undefined' ? null : additional;
                reduceOptions = this.props.reduceOptions;
                _context6.next = 39;
                return this.setState(function (prevState) {
                  return {
                    optionsCache: _objectSpread({}, prevState.optionsCache, _defineProperty({}, inputValue, _objectSpread({}, currentOptions, {
                      options: reduceOptions(currentOptions.options, options, newAdditional),
                      hasMore: !!hasMore,
                      isLoading: false,
                      isFirstLoad: false,
                      additional: newAdditional
                    })))
                  };
                });

              case 39:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[16, 27]]);
      }));

      function loadOptions() {
        return _loadOptions.apply(this, arguments);
      }

      return loadOptions;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          selectRef = _this$props2.selectRef,
          components = _this$props2.components,
          SelectComponent = _this$props2.SelectComponent,
          inputValue = _this$props2.inputValue,
          props = _objectWithoutProperties(_this$props2, ["selectRef", "components", "SelectComponent", "inputValue"]);

      var optionsCache = this.state.optionsCache;
      var currentOptions = optionsCache[inputValue] || this.getInitialCache();
      return /*#__PURE__*/React.createElement(SelectComponent, _extends({}, props, {
        inputValue: inputValue,
        handleScrolledToBottom: this.handleScrolledToBottom,
        isLoading: currentOptions.isLoading,
        isFirstLoad: currentOptions.isFirstLoad,
        options: currentOptions.options,
        components: _objectSpread({
          MenuList: MenuList
        }, components),
        ref: selectRef
      }));
    }
  }]);

  return AsyncPaginateBase;
}(Component);

AsyncPaginateBase.propTypes = {
  loadOptions: PropTypes.func.isRequired,
  loadOptionsOnMenuOpen: PropTypes.bool,
  debounceTimeout: PropTypes.number,
  shouldLoadMore: PropTypes.func,
  inputValue: PropTypes.string.isRequired,
  menuIsOpen: PropTypes.bool.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  defaultOptions: PropTypes.oneOfType([PropTypes.bool, PropTypes.arrayOf(PropTypes.object)]),
  // eslint-disable-next-line react/forbid-prop-types
  additional: PropTypes.any,
  reduceOptions: PropTypes.func,
  SelectComponent: PropTypes.elementType,
  components: PropTypes.objectOf(PropTypes.func),
  filterOption: PropTypes.func,
  onInputChange: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  cacheUniq: PropTypes.any,
  selectRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
};
AsyncPaginateBase.defaultProps = {
  debounceTimeout: 0,
  shouldLoadMore: defaultShouldLoadMore,
  options: null,
  defaultOptions: false,
  additional: null,
  reduceOptions: defaultReduceOptions,
  SelectComponent: Select,
  components: {},
  filterOption: null,
  cacheUniq: null,
  selectRef: null,
  loadOptionsOnMenuOpen: true
};
export default AsyncPaginateBase;